import React from "react";
import Block from "../Block/Block";
import {makeStyles} from "@material-ui/core/styles";

const FourColumnBlock = (props) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%',
            display: 'flow-root'
        },
        leftColumn: {
            ['@media (min-width:800px)']: {
                width: '25%',
                float: 'left'
            },
        },
        middleLeftColumn: {
            ['@media (min-width:800px)']: {
                width: '25%',
                float: 'left'
            },
        },
        middleRightColumn: {
            ['@media (min-width:800px)']: {
                width: '25%',
                float: 'left'
            },
        },
        rightColumn: {
            ['@media (min-width:800px)']: {
                width: '25%',
                float: 'left'
            },
        },
    }));
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div id={"left-" + props.block.id} data-new-id={"left-" + props.block.four_column_block.id} className={classes.leftColumn}>
                {[...props.block.four_column_block.leftColumn.keys()].map(key => (
                    <Block className="left-column" id={"four-column-block-" + props.block.four_column_block.id} form={props.form} handleChange={props.handleChange} block={props.block.four_column_block.leftColumn[key]} />
                ))}
            </div>
            <div id={"middle-left-" + props.block.id} data-new-id={"middle-left-" + props.block.four_column_block.id} className={classes.middleLeftColumn}>
                {[...props.block.four_column_block.middleLeftColumn.keys()].map(key => (
                    <Block className="middle-left-column" id={"four-column-block-" + props.block.four_column_block.id} form={props.form} handleChange={props.handleChange} block={props.block.four_column_block.middleLeftColumn[key]} />
                ))}
            </div>
            <div id={"middle-right-" + props.block.id} data-new-id={"middle-right-" + props.block.four_column_block.id} className={classes.middleRightColumn}>
                {[...props.block.four_column_block.middleRightColumn.keys()].map(key => (
                    <Block className="middle-right-column" id={"four-column-block-" + props.block.four_column_block.id} form={props.form} handleChange={props.handleChange} block={props.block.four_column_block.middleRightColumn[key]} />
                ))}
            </div>
            <div id={"right-" + props.block.id} data-new-id={"right-" + props.block.four_column_block.id} className={classes.rightColumn}>
                {[...props.block.four_column_block.rightColumn.keys()].map(key => (
                    <Block className="right-column" id={"four-column-block-" + props.block.four_column_block.id} form={props.form} handleChange={props.handleChange} block={props.block.four_column_block.rightColumn[key]} />
                ))}
            </div>
        </div>
    )
}

export default FourColumnBlock;